export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import type {FileCardListItem} from 'kpc';

interface Props {
    userFiles: FileCardListItem[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            userFiles: [
                {
                    key: 'img-1',
                    name: '店铺参考图.jpg',
                    src: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1200&q=80',
                    byte: 1024 * 420,
                },
                {
                    key: 'audio-1',
                    name: '旁白.mp3',
                    type: 'audio',
                    src: 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3',
                    byte: 1024 * 930,
                },
                {
                    key: 'file-1',
                    name: '分镜脚本.pdf',
                    type: 'file',
                    src: 'https://example.com/storyboard.pdf',
                    byte: 1024 * 120,
                },
            ],
        } as Props;
    }
}